export default __webpack_public_path__ + "static/media/illustration-work-3-w.7123e95e.webp";